import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import ContactModel from "common/components/commonTableModel/ContactModel";
import LeadModel from "common/components/commonTableModel/LeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LiaMousePointerSolid } from "react-icons/lia";
import { TaskSchema } from "common/schema";
import { postApi } from "common/services/api";
import moment from "moment";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import colors from "common/theme/foundations/colors";
import { useSelector, useDispatch } from "react-redux";
import { getApi } from "common/services/api";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";

const AddTask = (props) => {
  const { onClose, isOpen, fetchData } = props;
  const [isChecked, setIsChecked] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  const [assignmentToData, setAssignmentToData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const dispatch = useDispatch();
  const contactData = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const [list, setList] = useState({ contact: contactData || [], lead: [] });
  useEffect(() => {
    setList((prev) => ({
      ...prev,
      contact: contactData || [],
      lead: leadData || [],
    }));
  }, [contactData, leadData]);
  const initialValues = {
    title: "",
    category:
      props.leadContect === "contactView"
        ? "Contact"
        : props.leadContect === "leadView"
          ? "Lead"
          : "None",
    description: "",
    notes: "",
    assignmentTo:
      props.leadContect === "contactView" && props.id ? props.id : "",
    assignmentToLead:
      props.leadContect === "leadView" && props.id ? props.id : "",
    reminder: "",
    start: convertUtcToIst(new Date()),
    end: "",
    backgroundColor: colors.black,
    borderColor: colors.white,
    textColor: colors.white,
    allDay: isChecked === true ? "Yes" : "No",
    display: "",
    url: "",
    priority: "not_defined",
    createBy: userId,
  };
  useEffect(() => {
    if (isOpen) {
      setFieldValue("start", convertUtcToIst(new Date()));
    }
  }, [isOpen]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: TaskSchema,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });
  const [assignToError, setAssignToError] = useState({
    contact: "",
    lead: "",
  });
  const [isSubmit, setIsSubmit] = useState(false);

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const AddData = async () => {
    if (values.category === "Contact" && !values.assignmentTo) {
      setAssignToError({
        ...assignToError,
        contact: "Please select contact",
      });
      return;
    }
    if (values.category === "Lead" && !values.assignmentToLead) {
      setAssignToError({
        ...assignToError,
        lead: "Please select lead",
      });
      return;
    }
    try {
      setIsLoading(true);

      if (values?.start) {
        values.start = isChecked
          ? moment(values.start).format("YYYY-MM-DD") || ""
          : moment(values.start).format("YYYY-MM-DDTHH:mm") || "";
      }
      if (values?.end) {
        values.end = isChecked
          ? moment(values.end).format("YYY-MM-DD") || ""
          : moment(values.end).format("YYYY-MM-DDTHH:mm") || "";
      }

      let response = await postApi("api/task/add", values);
      if (response.status === 200) {
        fetchData();
        toast.success("Task Added Successfully");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
      setAssignToError({ lead: "", contact: "" });
      setIsSubmit(false);
      formik.resetForm();
      onClose();
    }
  };
  const getContactListData = () => {
    dispatch(getContactList({ fetchAllData: true }));
  };


  async function getLeadListData() {
    dispatch(getLeadList({ fetchAllData: true }));

  }
  useEffect(() => {
    if (isOpen) {
      getContactListData();
      getLeadListData();
    }
  }, [isOpen]);
  const getListDetails = async () => {
    try {
      let result = [];
      if (values.category === "Contact") {
        result = list.contact;
      } else if (values.category === "Lead") {
        result = list.lead;
      }
      setAssignmentToData(result);
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getListDetails();
  }, [values.category, list]);

  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    setIsSubmit(false);
    handleChange(e);
  }
  function closeHandler() {
    setAssignToError({ lead: "", contact: "" });
    setIsSubmit(false);
    formik.resetForm(); // Reset the form before closing
  }

  return (
    <Modal isOpen={isOpen} size={"xl"}>
      <ModalOverlay />
      <ModalContent height={"600px"} maxW={"700px"}>
        <ModalHeader justifyContent="space-between" display="flex">
          Create Task
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => {
              closeHandler();
              return props.from ? onClose(false) : onClose(); // Then close based on the `props.from` condition
            }}
            icon={<CloseIcon />}
          />
        </ModalHeader>
        <ModalBody overflowY={"auto"} height={"700px"}>
          {/* Contact Model  */}
          <ContactModel
            isOpen={contactModelOpen}
            data={assignmentToData}
            onClose={setContactModel}
            fieldName="assignmentTo"
            setFieldValue={setFieldValue}
          />
          {/* Lead Model  */}
          <LeadModel
            isOpen={leadModelOpen}
            data={assignmentToData}
            onClose={setLeadModel}
            fieldName="assignmentToLead"
            setFieldValue={setFieldValue}
          />

          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Title<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.title}
                name="title"
                placeholder="Title"
                fontWeight="500"
                borderColor={errors?.title && touched?.title ? "red.300" : null}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.title && touched.title && errors.title}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.taskRelatedTo}
              </FormLabel>
              <Select
                onChange={(e) => {
                  setIsSubmit(false);
                  setFieldValue("category", e.target.value);
                  setFieldValue("assignmentTo", null);
                  setFieldValue("assignmentToLead", null);
                }}
                value={values.category}
              >
                <option value={constant.none}>{constant.none}</option>
                <option value={constant.contact}>{constant.contact}</option>
                <option value={constant.lead}>{constant.lead}</option>
              </Select>
              <Text mb="10px" color={"red"}>
                {errors.category && touched.category && errors.category}
              </Text>
            </GridItem>
            <GridItem
              colSpan={{ base: 12, md: values.category === "None" ? 12 : 6 }}
            >
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.taskDescription}
              </FormLabel>
              <Textarea
                resize={"none"}
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.description}
                name="description"
                placeholder="Description"
                fontWeight="500"
              />

              <Text mb="10px" color={"red"}>
                {" "}
                {errors.description &&
                  touched.description &&
                  errors.description}
              </Text>
            </GridItem>
            {values.category === "Contact" ? (
              <>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                  >
                    {constant.assignToContact} <Text color={"red"}>*</Text>
                  </FormLabel>
                  <Select
                    value={values.assignmentTo}
                    name="assignmentTo"
                    onChange={(e) => {
                      onChangeHandler(e);
                    }}
                    mb={
                      errors.assignmentTo && touched.assignmentTo
                        ? undefined
                        : "10px"
                    }
                    fontWeight="500"
                    placeholder={"Assign To"}
                    borderColor={
                      errors.assignmentTo && touched.assignmentTo
                        ? "red.300"
                        : null
                    }
                  >
                    {assignmentToData?.map((item) => {
                      return (
                        <option value={item._id} key={item._id}>
                          {values?.category === "Contact" && item?.contactName
                            ? item?.contactName
                            : "-"}
                        </option>
                      );
                    })}
                  </Select>
                  {assignToError.contact &&
                    !values.assignmentTo &&
                    isSubmit && (
                      <Text mb="10px" fontSize="sm" color={"red"}>
                        {" "}
                        {"Please select contact"}
                      </Text>
                    )}
                </GridItem>
              </>
            ) : values.category === "Lead" ? (
              <>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                  >
                    {constant.assignToLead} <Text color={"red"}>*</Text>
                  </FormLabel>
                  <Select
                    value={values.assignmentToLead}
                    name="assignmentToLead"
                    onChange={(e) => {
                      onChangeHandler(e);
                    }}
                    mb={
                      errors.assignmentToLead && touched.assignmentToLead
                        ? undefined
                        : "10px"
                    }
                    fontWeight="500"
                    placeholder={"Assign To"}
                    borderColor={
                      errors.assignmentToLead && touched.assignmentToLead
                        ? "red.300"
                        : null
                    }
                  >
                    {assignmentToData?.map((item) => {
                      return (
                        <option value={item._id} key={item._id}>
                          {values.category === "Lead" && item.leadName}
                        </option>
                      );
                    })}
                  </Select>
                  {assignToError.lead &&
                    !values.assignmentToLead &&
                    isSubmit && (
                      <Text mb="10px" fontSize="sm" color={"red"}>
                        {" "}
                        {"Please select lead"}
                      </Text>
                    )}
                </GridItem>
              </>
            ) : (
              ""
            )}

            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.startDate}
                <Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                type="datetime-local"
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.start}
                name="start"
                fontWeight="500"
                borderColor={errors?.start && touched?.start ? "red.300" : null}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.start && touched.start && errors.start}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.endDate}
              </FormLabel>
              <Input
                type={"datetime-local"}
                fontSize="sm"
                min={values.end}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.end}
                name="end"
                fontWeight="500"
                borderColor={errors?.end && touched?.end ? "red.300" : null}
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.end && touched.end && errors.end}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.url}
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.url}
                name="url"
                placeholder="Enter URL"
                fontWeight="500"
                borderColor={errors?.url && touched?.url ? "red.300" : null}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.url && touched.url && errors.url}
              </Text>
            </GridItem>

            <GridItem colSpan={{ base: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.notes}
              </FormLabel>
              <Textarea
                resize={"none"}
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.notes}
                name="notes"
                placeholder="Notes"
                fontWeight="500"
                borderColor={errors?.notes && touched?.notes ? "red.300" : null}
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.notes && touched.notes && errors.notes}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 12 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {crmConstant.priority}
              </FormLabel>
              <Select
                onChange={(e) => {
                  setIsSubmit(false);
                  setFieldValue("priority", e.target.value);
                }}
                value={values.priority}
              >
                {crmConstant.priorityList.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Select>

              <Text mb="10px" color={"red"}>
                {errors.priority && touched.priority && errors.priority}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, sm: 3 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.bgcolor}
              </FormLabel>
              <Input
                type="color"
                fontSize="sm"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.backgroundColor}
                name="backgroundColor"
                fontWeight="500"
                borderColor={
                  errors?.backgroundColor && touched?.backgroundColor
                    ? "red.300"
                    : null
                }
                className="roundedColorInput"
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.backgroundColor &&
                  touched.backgroundColor &&
                  errors.backgroundColor}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, sm: 3 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.borderolor}
              </FormLabel>
              <Input
                fontSize="sm"
                type="color"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.borderColor}
                name="borderColor"
                placeholder="borderColor"
                fontWeight="500"
                borderColor={
                  errors?.borderColor && touched?.borderColor ? "red.300" : null
                }
                className="roundedColorInput"
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.borderColor &&
                  touched.borderColor &&
                  errors.borderColor}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, sm: 3 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                {constant.textColor}
              </FormLabel>
              <Input
                fontSize="sm"
                type="color"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                onBlur={handleBlur}
                value={values.textColor}
                name="textColor"
                placeholder="textColor"
                fontWeight="500"
                textColor={
                  errors?.textColor && touched?.textColor ? "red.300" : null
                }
                className="roundedColorInput"
              />
              <Text mb="10px" color={"red"}>
                {" "}
                {errors.textColor && touched.textColor && errors.textColor}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            className="cancelBtn theme-btn2"
            size="sm"
            onClick={() => {
              closeHandler();
              return props.from ? onClose(false) : onClose();
            }}
          >
            Close
          </Button>

          {/* <Button size="sm" variant='brand' disabled={isLoading ? true : false} onClick={handleSubmit}>{isLoading ? <Spinner /> : 'Save'}</Button> */}
          <Button
            className="theme-btn1"
            sx={{ textTransform: "capitalize" }}
            size="sm"
            disabled={isLoading ? true : false}
            variant="brand"
            type="submit"
            onClick={() => {
              setIsSubmit(true);
              handleSubmit();
            }}
          >
            {isLoading ? (
              <Spinner
                size={20}
                paddingRight={5}
                border={`3px solid ${globalStyles.colors.loaderBorder}`}
                borderTop={`1px solid ${globalStyles.colors.transparent}`}
              />
            ) : (
              ""
            )}{" "}
            {constant.save}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddTask;
